import React from 'react'
import moment from 'moment'
//Moment
moment.locale('es')
let PropTypes = React.PropTypes
//Notify
import ReactNotify from 'react-notify'
import * as ReactNotifyCSS from '../../shared/ReactNotify/ReactNotify.css'
//Services axios
import api from '../../apiClient/v1'
//Componentes
import { TablaInventarios } from './TablaInventarios.jsx'
import { ModalTrigger, PublicarFondos} from './Modales.jsx'
import { Totales } from './Totales.jsx'
import { TablaFondos } from './TablaFondos.jsx'
//CSS
import css from './Fondos.css'
import classNames from 'classnames/bind'
let cx = classNames.bind(css)

export class AsignacionFondos extends React.Component{
    constructor(props){
        super(props)
        this.guardarFondoGeneral = this.guardarFondoGeneral.bind(this)
        this.sumaTotales = this.sumaTotales.bind(this)
        this.getLideresSemana = this.getLideresSemana.bind(this)
        this.state = {
            lideres: [],
            idRendicion: 0,
            estado_rendicion: 0,
            idLiderSeleccionado: 0,
            year: '',
            numero_semana: 0,
            semanaSeleccionada: '',
            semana: [],
            inventarios: [],
            fondoSemana: [],
            semanaServicios: [],
            viaticosLiquidacion: 0,
            fondosRendir: 0,
            fondoPendiente: 0,
            fondoGirar: 0,
            comunaInicio: 0, 
            totalColacionNocturna: 0, 
            totalViatico: 0, 
            totalAlojamiento: 0,
            totalAcercmientos: 0, 
            totalTraslados: 0,
            totalPasajeOperador: 0,
            totalOtros: 0,
            cargando: false,
            totales: {
                viaticosLiquidacion: 0,
                fondosRendir: 0,
                fondoPendiente: 0,
                fondoGirar: 0
            },
            error: []
        }
    }
    getChildContext(){
        return{
            inputChange: (index, servicio)=>{
                let semanaServicios = this.state.semanaServicios
                semanaServicios[index] = servicio
                this.setState({semanaServicios}, ()=>this.sumaTotales())
            },
            subirComprobante: (index, servicio)=>{
                console.log(servicio.comprobante, "idRendicion", this.state.idRendicion)
                let semanaServicios = this.state.semanaServicios
                let data = new FormData()
                data.append(servicio.dia, servicio.comprobante)
                let request = api.fondos().guardarPasaje(this.state.idRendicion, servicio.dia, data)
                request
                    .then(resp=>{
                        semanaServicios[index] = servicio
                        semanaServicios[index].idBoletoPasaje = resp.idBoletoPasaje
                        semanaServicios[index].nombre_comprobante = resp.nombre
                    })
                    .catch(err=>{
                        console.log(err)
                    })
                this.setState({semanaServicios}, ()=>this.sumaTotales())
                return request
            },
            saldoLiderChange:(fondoPendiente)=>{
                this.setState({fondoPendiente}, ()=>this.sumaTotales())
            },
            publicarFondos:(numero_comprobante, total)=>{
                let request = api.fondos().publicarFondos(this.state.idRendicion, numero_comprobante, total)
                request
                    .then(resp=>{
                        this.refs.notificator.info("Fondos", "Fondos Publicados", 5*1000)
                    })
                    .catch(()=>{})
                api.fondos().guardaFondoGeneral(this.state.idRendicion, this.state.idLiderSeleccionado, this.state.numero_semana, this.state.semanaServicios, this.state.totales)
                    .then(resp=>{
                        console.log(resp)
                    })
                    .catch(err=>{
                        console.log(err)
                    }) 
                return request
            },
            guardarFondo:(servicio)=>{
                api.fondos().guardaFondo(this.state.idRendicion, this.state.idLiderSeleccionado, this.state.numero_semana, servicio, this.state.totales)
                    .then(resp=>{
                        console.log(resp)
                    })
                    .catch(err=>{
                        console.log(err)
                    })
            },
            comprobantesDeposito:()=>{
                return api.fondos().comprobantesDeposito(this.state.idRendicion)
            },
            buscarHospedajes:(idComuna)=>{
                return api.hospedajes().getBuscarHospedajes(idComuna)
            },
            guardarDetalleHospedaje:(index, detalleHospedaje, servicio)=>{
                let request = api.fondos().guardarDetalleHospedaje(this.state.idRendicion, servicio, detalleHospedaje)
                request
                    .then(resp=>{
                        let semanaServicios = this.state.semanaServicios
                        semanaServicios[index].idDetalleHospedaje = resp.idDetalleHospedaje
                        semanaServicios[index].idHospedaje = resp.hospedaje
                        this.setState({semanaServicios},()=>this.state.semanaServicios)
                    })
                    .catch(err=>{
                        console.log(err)
                    })
                return request
            },
            guardaDatosPasaje:(index, idBoletoPasaje, datosPasaje)=>{
                let request = api.fondos().guardaDatosPasaje(this.state.idRendicion, idBoletoPasaje, datosPasaje)
                    .then(resp=>{
                        let semanaServicios = this.state.semanaServicios
                        semanaServicios[index].boletoPasaje = resp
                        this.setState({semanaServicios},()=>console.log(this.state.semanaServicios))
                    })
                    .catch(err=>{
                    })
                return request
            }
        }
    }
    onSelectLiderChanged(evt){
        this.setState({
            idLiderSeleccionado: evt.target.value,
            inventarios: [],
            semanaServicios: [],
            semana: [],
            cargando: true
        },()=>this.onGenerarFondos())
    }
    onWeekChange(evt){
        const [year, week] = evt.target.value.split('-W');
        this.setState({
            semanaSeleccionada: evt.target.value,
            year: year,
            numero_semana: week,
            inventarios: [],
            semanaServicios: [],
            semana: [],
            idLiderSeleccionado: 0,
            cargando: true
        },()=>this.getLideresSemana())
    }
    getLideresSemana(){
        if(this.state.numero_semana){
            let fechaInicio = moment(`${this.state.year}-W${this.state.numero_semana}`).startOf('isoWeek').format('YYYY-MM-DD')
            let fechaFin = moment(`${this.state.year}-W${this.state.numero_semana}`).endOf('isoWeek').format('YYYY-MM-DD')

            api.fondos().getLideresInventarios(fechaInicio, fechaFin)
                .then(lideres=>{
                    this.setState({
                        lideres,
                        cargando: false
                    })
                })
                .catch(err=>{
                    console.log(err)
                })
        }    
    }
    onGenerarFondos(){
        if(!this.state.idLiderSeleccionado || !this.state.numero_semana){
            this.refs.notificator.error("Fondos", "Seleccione Lider y Semana", 5*1000)
        }
        let fechaInicio = moment(`${this.state.year}-W${this.state.numero_semana}`).startOf('isoWeek').format('YYYY-MM-DD')
        let fechaFin = moment(`${this.state.year}-W${this.state.numero_semana}`).endOf('isoWeek').format('YYYY-MM-DD')

        api.fondos().getInventariosLider(this.state.idLiderSeleccionado, fechaInicio, fechaFin)
            .then(resp=>{
                if(resp.inventarios.length > 0){
                    this.setState({
                        idRendicion: resp.idRendicion,
                        estado_rendicion: resp.estado_rendicion,
                        comunaInicio:resp.comunaInicio,
                        fondoPendiente: resp.saldoLider,
                        inventarios: resp.inventarios,
                        semanaServicios: resp.semanaServicios,
                        error: [],
                        cargando: false
                    }, ()=>this.sumaTotales())
                }else{
                    this.refs.notificator.info("Fondos", "No hay inventarios en la semana seleccionada.", 5*1000)
                }
            })
            .catch(err=>{
                console.log(err)
                this.setState({error: err.data})
            })
    }
    onCancel(){
        this.setState({
            inventarios: [],
            semanaServicios: [],
            semana: [],
            idLiderSeleccionado: 0
        })
    }
    sumaTotales(){
        let viaticosLiquidacion = 0
        let fondosRendir = 0
        let totalColacionNocturna = 0
        let totalViatico = 0
        let totalAlojamiento = 0
        let totalAcercmientos = 0
        let totalTraslados = 0
        let totalPasajeOperador = 0
        let totalOtros = 0
        let semanaServicios = this.state.semanaServicios
        
        semanaServicios.forEach(servicio => {
            if(servicio.colacion_nocturna && servicio.diaTrabajado){
                viaticosLiquidacion = parseInt(servicio.colacion_nocturna) + viaticosLiquidacion
                totalColacionNocturna = parseInt(servicio.colacion_nocturna) + totalColacionNocturna
            }
            if(servicio.viatico && servicio.diaTrabajado){
                viaticosLiquidacion = parseInt(servicio.viatico) + viaticosLiquidacion
                totalViatico = parseInt(servicio.viatico) + totalViatico
            }
            if(servicio.acercamientos && servicio.diaTrabajado){
                fondosRendir = parseInt(servicio.acercamientos) + fondosRendir
                totalAcercmientos = parseInt(servicio.acercamientos) + totalAcercmientos
            }
            if(servicio.alojamiento && servicio.diaTrabajado){
                viaticosLiquidacion = parseInt(servicio.alojamiento) + viaticosLiquidacion
                totalAlojamiento = parseInt(servicio.alojamiento) + totalAlojamiento
            }
            if(servicio.traslados && servicio.diaTrabajado && !servicio.pasajeSei){
                fondosRendir = parseInt(servicio.traslados) + fondosRendir
                totalTraslados = parseInt(servicio.traslados) + totalTraslados
            }
            if(servicio.pasajeOperador && servicio.diaTrabajado){
                fondosRendir = parseInt(servicio.pasajeOperador) + fondosRendir
                totalPasajeOperador = parseInt(servicio.pasajeOperador) + totalPasajeOperador
            }
            if(servicio.otros && servicio.diaTrabajado){
                fondosRendir = parseInt(servicio.otros) + fondosRendir
                totalOtros = parseInt(servicio.otros) + totalOtros
            }
        })

        let totales = {
            viaticosLiquidacion: viaticosLiquidacion,
            fondosRendir: fondosRendir,
            fondoPendiente: this.state.fondoPendiente,
            fondoGirar: (fondosRendir + viaticosLiquidacion) - (this.state.fondoPendiente? this.state.fondoPendiente : 0)
        }

        this.setState({
            totales, 
            totalColacionNocturna, 
            totalViatico, 
            totalAlojamiento, 
            totalAcercmientos, 
            totalTraslados, 
            totalPasajeOperador, 
            totalOtros
        })
    }
    guardarFondoGeneral(){
        this.refs.notificator.info("Fondos", "Guardando fondos...", 5*1000)
        api.fondos().guardaFondoGeneral(this.state.idRendicion, this.state.idLiderSeleccionado, this.state.numero_semana, this.state.semanaServicios, this.state.totales)
            .then(resp=>{
                console.log(resp)
                this.refs.notificator.success("Fondos", "Fondos Guardados correctamente", 5*1000)
            })
            .catch(err=>{
                console.log(err)
                this.refs.notificator.error("Fondos", "Ocurrió un error al guardar los fondos", 5*1000)
            })
    }
    render() {
        return (
            <div className="container-fluid">
                <ReactNotify ref='notificator' className={ReactNotifyCSS}/>
                <div className="panel panel-default">
                    <div className="panel-body">
                        <div className="page-header row">
                            <div className={cx("col-md-12", 'titleFinance')}>
                                <div className={cx("col-md-10", 'divTitle')}>
                                    <h3><span className="glyphicon glyphicon-usd"></span> Asignación de fondos</h3>
                                </div>
                                <div className={cx("col-md-1", 'divNavBar')}>
                                    <ModalTrigger>
                                        {(isVisible, showModal, hideModal)=>
                                            <button className={"btn btn-md btn-info"} onClick={showModal}>
                                                <span className={'glyphicon glyphicon-envelope'}></span> Publicar
                                                {isVisible && <PublicarFondos
                                                    hideModal={hideModal}
                                                    index={this.props.index}
                                                    estado_rendicion={this.state.estado_rendicion}
                                                    total={this.state.totales.fondoGirar}
                                                />}
                                            </button>
                                        }
                                    </ModalTrigger>
                                </div>
                                <div className={cx("col-md-1", 'divNavBar')}>
                                    <a className="btn btn-md btn-success"
                                       href={`/api/rendiciones/fondos/${this.state.numero_semana}/${this.state.year}/descargar-excel`}>
                                        <span className={'glyphicon glyphicon-export'}></span> Excel
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-12">
                            <div className={'col-md-2 form-group '}>
                                <label className="control-label" htmlFor="selectSemana">Seleccionar Semana</label>
                                <input type="week" className={"form-control "+css.inputGeneral}
                                       value={this.state.semanaSeleccionada}
                                       onChange={this.onWeekChange.bind(this)}/>
                                {this.state.error.fechas && <span className={cx('form__error-message')}>{this.state.error.fechas}</span>}
                            </div>
                            {/* SELECTOR DE LIDER */}
                            <div className={'col-md-3 form-group '}>
                                <label className="control-label">Lideres</label>
                                <select className={"form-control "+css.inputGeneral}
                                        value={this.state.idLiderSeleccionado}
                                        onChange={this.onSelectLiderChanged.bind(this)}>
                                    <option value="0">Seleccione Lider</option>
                                    {this.state.lideres.map((lider, index)=>{
                                        return <option key={index} value={lider.idLider}>{lider.nombre}</option>
                                    })}
                                </select>
                                {this.state.error.idLider && <span className={cx('form__error-message')}>{this.state.error.idLider}</span>}
                            </div>
                            <div className={'col-md-2 form-group '}>
                                <div className="control-label">&nbsp;</div>
                                {this.state.idLiderSeleccionado?
                                    <button className="btn btn-md btn-primary"
                                            onClick={this.guardarFondoGeneral}
                                            disabled={this.state.cargando}>
                                        <span className={'glyphicon glyphicon-saved'}></span> Guardar
                                    </button>
                                    :
                                    null
                                }
                            </div>
                        </div>
                        {this.state.inventarios.length === 0 ?
                            null
                            :
                            <div className={cx("col-md-12", 'divFinance')}>
                                <div className="row">
                                    <div className="col-md-11">
                                        <h5 className={css.textInformation}>Listado de servicios a realizar en la semana seleccionada*</h5>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-9">
                                        <TablaInventarios
                                            inventarios={this.state.inventarios}
                                        />
                                    </div>
                                    <div className="col-md-3">
                                        <Totales
                                            totales={this.state.totales}
                                        />
                                    </div>
                                </div>
                            </div>
                        }
                        {this.state.inventarios.length === 0 ?
                            null
                            :
                            <div className={cx("col-md-12", 'divFinance')}>
                                <div className="row">
                                    <div className="col-md-11">
                                        <h5 className={css.textInformation}>Listado de fondos asignados a trabajador*</h5>
                                    </div>
                                </div>
                                <div className="row">
                                    <TablaFondos
                                        semanaServicios={this.state.semanaServicios}
                                        totalColacionNocturna={this.state.totalColacionNocturna}
                                        totalViatico={this.state.totalViatico}
                                        totalAlojamiento={this.state.totalAlojamiento}
                                        totalAcercmientos={this.state.totalAcercmientos}
                                        totalTraslados={this.state.totalTraslados}
                                        totalPasajeOperador={this.state.totalPasajeOperador}
                                        totalOtros={this.state.totalOtros}
                                        puedeModificar={true}
                                    />
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
        )
    }
}
AsignacionFondos.childContextTypes = {
    inputChange: PropTypes.func,
    saldoLiderChange: PropTypes.func,
    publicarFondos: PropTypes.func,
    subirComprobante: PropTypes.func,
    guardarFondo: PropTypes.func,
    comprobantesDeposito: PropTypes.func,
    buscarHospedajes: PropTypes.func,
    guardarDetalleHospedaje: PropTypes.func,
    guardaDatosPasaje: PropTypes.func
}


// WEBPACK FOOTER //
// ./frontEnd/contabilidad/asignacion-fondos/AsignacionFondos.jsx